import { useEffect, useRef } from 'react';
import { useAccessToken } from '@app/auth';
import { fetchApi } from '@app/hooks/api';

/**
 * Hook to fire a page view event using the existing audit client-event endpoint.
 * Fires exactly once per eventName per mount, regardless of re-renders.
 * Example: usePageView('PAGE_VISITED_ENVIRONMENT_DASHBOARD')
 */
export function usePageView(eventName: string) {
  const getToken = useAccessToken();
  const firedRef = useRef<string | null>(null);

  useEffect(() => {
    // Guard: only fire once per eventName per mount cycle
    if (firedRef.current === eventName) return;
    firedRef.current = eventName;

    const firePageView = async () => {
      try {
        await fetchApi('/api/audit/client-event', getToken, {
          method: 'POST',
          body: JSON.stringify({
            eventName,
            pageUrl: window.location.pathname,
            httpMethod: 'CLIENT',
          }),
        });
      } catch (err) {
        console.debug('Page view tracking failed:', err);
      }
    };

    firePageView();
  // getToken intentionally excluded — it can change reference without changing identity
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventName]);
}
